export class HolidayPlanner {
	/**
	 * Updates the holiday planner account access items based on the counter API.
	 *
	 * @param {jQuery|HTMLElement|NodeList} items
	 * @param {number|null} total
	 */
	static async updateHolidayPlannerAccountAccess(items, total = null) {
		const updateItems = (totalValue) => {
			items.each(function () {
				const $item = $(this);
				const $icon = $item.find('.icon-user, .icon-user-active');
				const $totalLabel = $item.find('.total');

				// Update data-total attribute
				$item.attr('data-total', totalValue);

				// Update total count labels
				if ($totalLabel.length) {
					$totalLabel.text(totalValue);
				}

				if (totalValue > 0) {
					// Update icon
					if ($icon.hasClass('icon-user')) {
						$icon.removeClass('icon-user').addClass('icon-user-active');
					}
				} else {
					// Reset icon
					if ($icon.hasClass('icon-user-active')) {
						$icon.removeClass('icon-user-active').addClass('icon-user');
					}
				}
			});
		};

		if (total !== null && typeof total !== 'undefined') {
			const totalInt = parseInt(total, 10);
			if (!isNaN(totalInt)) {
				updateItems(totalInt);
				return;
			}
		}

		const endpoint = window?.base_client?.endpoints?.holiday_planner_counter;
		if (!endpoint || !items || items.length === 0) {
			return;
		}

		try {
			const response = await fetch(endpoint, {
				mode: 'cors',
				credentials: 'include',
				headers: {
					'Accept': 'application/json'
				}
			});

			if (!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}

			const data = await response.json();
			const totalFromApi = data?.count?.total || 0;

			updateItems(totalFromApi);
		} catch (error) {
			console.warn('Could not update holiday planner access counter:', error);
		}
	}
}
